import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid , Icon , Card , Button , Checkbox } from 'semantic-ui-react';

const styles = {
  mainWrapper : {
    paddingRight : '3.5%'
  },
  section : {
    marginTop : '20px'
  }
}

class ServiceDisplay extends Component {
  constructor(props){
    super(props);
    const { string } = this.props;
    this.state = {
      products : [
        { header : 'basicCs' , price : 0 , desc : 'basicCsDes' , image : '' },
        { header : 'premiumCs' , price : `25%${string['invoicePrice']}` , desc : 'premiumCsDes' , image : '' }
      ]
    }
  }
  _renderProductSection(product){
    const { string } = this.props;
    return(
      <Card
        style={{  }}
        meta={`${string['price']} : ${product.price} ${string['currency']}`}
        key={product.header}
        description={string[product.desc]}
        header={string[product.header]}
      />
    )
  }
  render(){
    const { products } = this.state;
    return (
      <Grid.Column style={styles.mainWrapper} width={12}>
        <Card.Group itemsPerRow={2} className="stackable">
        {products.map((product)=>this._renderProductSection(product))}
        </Card.Group>
      </Grid.Column>
    );
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

export default connect(mapStateToProps,null)(ServiceDisplay)



/** WEBPACK FOOTER **
 ** ./src/containers/price/serviceDisplay.js
 **/